import React, { useEffect, useState } from 'react';
import Calendar from '../calendar/calendar';
import OutsideClick from '../outside-click/outside-click';
import useDate from '../../hooks/useDate';
import { useFormikContext } from 'formik';
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';

const DateField = (props) => {
    const { translate } = useLocale();
    const [visible, setVisible] = useState(false);
    const { values, setFieldValue } = useFormikContext();

    const objectValues = values as object;
    const [date, setDate] = useState<Date | null>(objectValues[props.valueName])

    //console.log(`---> DateField reinit for what reason? ${objectValues[props.valueName]}`);

    const {
        // date,
        matrix,
        // setDate,
        decMonth,
        incMonth,
        decYear,
        incYear,
        today
    } = useDate(objectValues[props.valueName], date, setDate)

    const localeYearOpts: any = { year: 'numeric', month: 'numeric', day: 'numeric' };

    useEffect(() => {
        if (date) {
            setFieldValue(props.valueName, date);
        }
    }, [date]);

    useEffect(() => {
        const newValues = values as object;
        setDate(newValues[props.valueName]);
    }, [values])

    const safelyGetDate = () => { if (!date) { setDate(new Date(Date.now())); } return date; };
    return (
        <div className="flex flex-col w-full">
            <div
                className={`flex flex-row ${props.width ?? "w-full"} justify-between items-center`}
                onClick={() => setVisible(true)}
                // Added an onMouseDown event to enable the calendar to be shown
                // before another instance of the same component is hidden.
                // This is a useful workaround in instances where the calendar
                // may increase the height of the parent container, and clicking
                // on the second instance of the DateField would decrease the 
                // height of the parent container before opening the second calendar,
                // causing the second calendar to not open.
                onMouseDown={() => { props.useOnMouseDown && setVisible(true) }}
            >
                <span className={`p-1 text-sm bg-gray-input w-full ${date ? "text-gray-800" : "text-gray-500"}`} data-cy={props.dataCy}>
                    {date ? date.toLocaleString([], { ...localeYearOpts }) : (props.placeholder || translate.byKey(TranslationKeys.selectDate))}
                </span>
            </div>
            <div className="relative">
                {visible ? (
                    <OutsideClick onClick={() => setVisible(false)}>
                        <div
                            className={`flex flex-row shadow-2xl border ${
                                props.width ?? "w-auto"
                            } justify-between items-center text-xs mt-1 p-1 bg-white z-50 ${
                                props.className ? props.className : "fixed"
                            }`}
                        >
                            <Calendar
                                date={safelyGetDate()}
                                matrix={matrix}
                                setDate={setDate}
                                decMonth={decMonth}
                                incMonth={incMonth}
                                decYear={decYear}
                                incYear={incYear}
                                today={today}
                            />
                        </div>
                    </OutsideClick>
                ) : null}
            </div>
        </div>
    );
}

export default DateField;
